import React, {useCallback,useEffect,useState} from 'react';
import PropTypes from 'prop-types';
import Flag from '../../Flag';
import classNames from 'classnames';
import {availableInputThemes} from '../../theme';
import styles from './Textarea.css';

const {bool, func, number, string, oneOf} = PropTypes;

function Textarea(props) {
  const {
    className = '',
    errorMessage = '',
    theme = 'default',
    size = 'medium',
    height = 'short',
    maxLength = null,
    showRemaining,
    value = null,
    onChange = null,
    ...inputProps
  } = props;

  const TextareaStyles = classNames(
    styles.Textarea,
    styles[`height-${height}`],
    styles[`theme-${theme}`],
    styles[`size-${size}`],
  );

  const [internalValue, setInternalValue] = useState(null);

  const handleOnChange = useCallback(e => {
    const val = e.target.value;

    if (maxLength !== null && val.length > maxLength) {
      // Truncate the value if it exceeds maxLength
      setInternalValue(val.slice(0, maxLength));
    } else {
      setInternalValue(val);
    }

    onChange && onChange(e);
  }, [onChange, maxLength]);

  useEffect(() => {
    setInternalValue(value?.slice(0, maxLength ?? undefined));
  }, [value, setInternalValue]);

  return (
    <div className={TextareaStyles}>
      <textarea
        {...inputProps}
        maxLength={maxLength !== null ? maxLength : undefined}
        value={internalValue || ''}
        onChange={handleOnChange}
        className={classNames(styles.textarea, {[styles.warning]: errorMessage}, className)}
      />

      {showRemaining && maxLength && (
        <div className={styles.status}>
          {internalValue?.length || 0} / {maxLength} Maximum
        </div>
      )}

      {errorMessage ? <Flag>{errorMessage}</Flag> : ''}
    </div>
  );
}

Textarea.propTypes = {
  className: string,
  errorMessage: string,
  theme: oneOf(availableInputThemes),
  size: oneOf(['medium', 'large']),
  height: oneOf(['short', 'tall']),
  maxLength: number,
  value: string,
  onChange: func,
  showRemaining: bool,
};

export default Textarea;
